// extracted by mini-css-extract-plugin
export default {"Burger":"burger_icon_Burger__-vHUK"};